import type { FireflyRuntime, ModuleRegisterFunction } from "@squide/firefly";

export const registerFeedback: ModuleRegisterFunction<FireflyRuntime> = async runtime => {
    if (runtime.isMswEnabled) {
        const [{ feedbackInboxRequestHandler }, { feedbackCatalogRequestHandler }] = await Promise.all([import("./mocks/inbox/feedbackInboxRequestHandler.ts"), import("./mocks/catalog/feedbackCatalogRequestHandler.ts")]);

        runtime.registerRequestHandlers([feedbackInboxRequestHandler, feedbackCatalogRequestHandler]);
    }
};
